import React from "react";
import { Flex, SkeletonCircle } from "@chakra-ui/react";
import TabButton from "components/RFQ/TabButton/TabButton"; // 경로 확인 필요
import SkeletonBase from "newui/components/Skeleton"; // 경로 확인 필요
import { validStepChecker } from "../createRFQUtils"; // 경로 확인 필요

export const RFQTabNavigation = ({
	isLoading,
	tabButtonList,
	selectedTab,
	completedSteps,
	touchedTabs,
	formikRef,
	isTemplate,
	isEdit,
	rfqData,
	onChangeTab,
	isQuoteValid,
}) => {
	if (isLoading) {
		return (
			<div className="mb-2 flex w-full gap-4">
				{tabButtonList?.map((_, index) => (
					<div
						key={index}
						className="w-full space-y-4"
					>
						<SkeletonBase
							height="8px"
							className="!w-full"
						/>
						<Flex className="items-center gap-3">
							<SkeletonCircle startColor="lightgray" />
							<SkeletonBase />
						</Flex>
					</div>
				))}
			</div>
		);
	}

	return (
		<div
			id="tab-button-rfq"
			className="mb-2 flex gap-4"
		>
			{tabButtonList?.map((tab, index) => {
				const currentErrors = formikRef.current?.errors ?? {};
				const currentValues = formikRef.current?.values ?? {};

				const isQuoteTab = tab.value === 4;

				const isStepGenerallyInvalid = isQuoteTab ? !isQuoteValid : !validStepChecker(
					tab.value,
					currentErrors,
					isTemplate
				).isValid;

				const isValidNow = rfqData?.isQuoteTabValid;

				const showError = (isQuoteTab && !isQuoteValid) || 
					(isStepGenerallyInvalid && touchedTabs.includes(tab.value));

				const showFinished =
					completedSteps.includes(tab.value) &&
					!isStepGenerallyInvalid;

			return (
					<TabButton
						key={index}
						{...tab}
						selectedTab={selectedTab}
						isActive={tab.value === selectedTab}
						onClick={() => onChangeTab(tab)}
						isFinished={showFinished}
						isError={showError}
					/>
				);
			})}
		</div>
	);
};
